import React from "react";
import SearchFilter from "components/searchFilter";
import useTranslation from "utils/hooks/useTranslation";

interface IPropsSearchFilterLocation {
  locationUpdateFilter: (...args) => void;
  locationChangeFieldValue: (...args) => void;
}

const LocationFilter = ({ locationUpdateFilter, locationChangeFieldValue }: IPropsSearchFilterLocation) => {
  const SEARCH_PLACEHOLDER = `${useTranslation({
    id: "search_structure_or_name",
  })}...`;

  return <SearchFilter placeholder={SEARCH_PLACEHOLDER} updateFilter={locationUpdateFilter} changeFieldValue={locationChangeFieldValue} numbersTypedCharacters={3} />;
};

export default LocationFilter;
